import { z } from 'zod';
import { createTopic } from '../lib';

const externalLinkClickedEventSchema = z.object({
  externalUrl: z
    .string()
    .describe('The external URL where the link redirects the user.'),
  currentPage: z
    .string()
    .describe('The current page where the user was when the link was clicked.'),
});

export type externalLinkClickedEvent = z.infer<
  typeof externalLinkClickedEventSchema
>;

export const externalLinkClickedTopic = createTopic<externalLinkClickedEvent>(
  {
    namespace: 'platform',
    name: 'external-link-clicked',
    description: 'The user clicked on a link to an external domain',
  },
  externalLinkClickedEventSchema,
);
